module.exports = __webpack_public_path__ + "static/powerbi-merge-values-before-6755c7da2728e61d2f51e09b4b0ce3b9.png";